import { Functions, httpsCallable } from '@angular/fire/functions';
import {
  CreateOrganizationAdminUserRequest,
  CreateOrganizationAdminUserResponse,
} from './create-organization-admin-user.types';

export function onCallCreateOrganizationAdminUser(functions: Functions) {
  return async (request: CreateOrganizationAdminUserRequest) => {
    const fn = httpsCallable<CreateOrganizationAdminUserRequest, CreateOrganizationAdminUserResponse>(
      functions,
      'onCallCreateOrganizationAdminUser'
    );
    const { data } = await fn(request);
    return data;
  };
}
